import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
var ns = /*#__PURE__*/function () {
  function ns(t) {
    _classCallCheck(this, ns);
    this.productId = t, this.productId = t;
  }
  _createClass(ns, [{
    key: "xc",
    value: function xc(t) {
      return null == this.productId || t[0] === this.productId;
    }
  }, {
    key: "dt",
    value: function dt() {
      return this.productId;
    }
  }], [{
    key: "fromJson",
    value: function fromJson(t) {
      return new ns(t ? t.product_id : null);
    }
  }]);
  return ns;
}();
export { ns as default };